import React, { useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { FaEdit, FaEye, FaPlus } from "react-icons/fa";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import OutletTypeTableModalContent from "../ModalContent/OutletTypeTableModalContent";
import { useOutletTypeList } from "./hooks/useSettingsMasters";
import { useNavigate } from "react-router-dom";
const OutletTypeDataColumns = (
  handleEdit: (row: any) => void,
  handleModuleEdit: (row: any) => void
) => [
  {
    name: "Name",
    selector: (row: { OutlettypeName: string }) => row?.OutlettypeName || "-",
    sortable: true,
    minWidth: "200px",
    wrap: true,
  },
  {
    name: "Is Primary",
    selector: (row: { Isoutletprimary: string | number }) =>
      row?.Isoutletprimary == 0 ? "No" : "Yes",
    sortable: true,
    minWidth: "180px",
    wrap: true,
  },
  {
    name: "Is End Customer",
    selector: (row: { Isoutletendcustomer: string | number }) =>
      row?.Isoutletendcustomer == 0 ? "No" : "Yes",
    sortable: true,
    minWidth: "180px",
    wrap: true,
  },
  {
    name: "Active",
    selector: (row: { Isenabled: string | number }) =>
      row?.Isenabled == 0 ? "No" : "Yes",
    sortable: true,
    minWidth: "180px",
    wrap: true,
  },
  {
    name: "Action",
    minWidth: "300px",
    cell: (row: any) => (
      <>
        <button
          onClick={() => handleEdit(row)}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
        <button
          onClick={() => handleModuleEdit(row)}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{
            borderRadius: "20px",
            padding: "3px",
            width: "180px",
            marginLeft: "10px",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} /> Outlet Module Type
        </button>
      </>
    ),
  },
];

const OutletTypeTable = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalStatus, setIsModalStatus] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [outletTypeId, setOutletTypeId] = useState("");

  const { data: outletTypeData } = useOutletTypeList({ enable: true });

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setIsModalStatus("");
    setSelectedRow(null);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setIsModalStatus("");
    setSelectedRow(null);
  };

  const handleEdit = (row: any) => {
    setIsModalOpen(!isModalOpen);
    setIsModalStatus("Edit");
    setSelectedRow(row);
    setOutletTypeId(row?.OutlettypeId);
  };

  const handleModuleEdit = (row: any) => {
    // console.log("ROW::::::::", row);
    navigate("/settings/masters/outlettype/outletmoduletype", {
      state: { outletTypeId: row?.OutlettypeId },
    });
  };

  return (
    <div className="container mt-3">
      <BasicDataTable
        Title="Outlet Type"
        data={outletTypeData?.data || []}
        columns={OutletTypeDataColumns(handleEdit, handleModuleEdit)}
        search={false}
        headerContent={
          <button
            onClick={() => toggleModal()}
            className="btn btn-info"
            style={{
              borderRadius: "20px",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaPlus /> <span>Add Outlet Type</span>
          </button>
        }
      />
      <RouteModal
        isOpen={isModalOpen}
        title="Add Outlet Type"
        toggle={toggleModal}
        size="md"
        content={
          <OutletTypeTableModalContent
            handleClose={handleClose}
            isModalStatus={isModalStatus}
            selectedRow={selectedRow}
            outletTypeId={outletTypeId}
          />
        }
      />
    </div>
  );
};

export default OutletTypeTable;
